/* eslint-disable */
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ClientListTable from "layouts/person/ClientListTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import personService from "services/personService";
import inactivePersonTableData from "./data/inactivePersonTableData";

function InactivePersons() {
  const navigate = useNavigate();
  const location = useLocation();

  const [persons, setPersons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await personService.getInactiveClients();
      setPersons(data || []);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, location.key]);

  useEffect(() => {
    const onFocus = () => load();

    const onVisibility = () => {
      if (document.visibilityState === "visible") load();
    };

    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [load]);
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Clientes inactivos
                </MDTypography>
                <Button
                  color="inherit"
                  onClick={() => navigate("/person", { replace: true })}
                >
                  Volver a activos
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <ClientListTable
                  persons={persons}
                  isLoading={isLoading}
                  makeTable={inactivePersonTableData}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default InactivePersons;
